import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./Pages/Home";
import AboutUs from "./Pages/about/AboutUs";
import CompanyBranch from "./Pages/about/CompanyBranch";
import PersonalLoan from "./Pages/PersonalLoan/PersonalLoan";
import PersonalLoanTypes from "./Pages/PersonalLoan/PersonalLoanTypes";
import WhyCasproFinance from "./Pages/PersonalLoan/WhyCasproFinance";
import HomeLoan from "./Pages/HomeLoan/HomeLoan";
import EligibilityCriteria from "./Pages/HomeLoan/EligibilityCriteria";
import DocumemtsRequired from "./Pages/HomeLoan/DocumentsRequired";
import BusinessLoan from "./Pages/BusinessLoan/BusinessLoan";
import Eligibility from './Pages/BusinessLoan/Eligibility';
import TypeOfBusinessLoan from "./Pages/BusinessLoan/TypeOfBusinessLoan";
import CarLoanBalanceTransferTopup from "./Pages/CarRefinance/CarLoanBalanceTransferTopup";
import LoanAgainstCar from "./Pages/CarRefinance/LoanAgainstCar";
import RefinancePurchase from "./Pages/CarRefinance/RefinancePurchase";
import Contact from "./Pages/Contact";
import HomeLoanAzamgarh from "./Pages/FooterPage/HomeLoanAzamgarh";
import HomeLoanBallia from "./Pages/FooterPage/HomeLoanBallia";
import HomeLoanVaranasi from "./Pages/FooterPage/HomeLoanVaranasi";
import HomeLoanGhazipur from "./Pages/FooterPage/HomeLoanGhazipur";
import HomeLoanChandauli from "./Pages/FooterPage/HomeLoanChandauli";
import PersonalLoanAzamgarh from "./Pages/FooterPage/PersonalLoanAzamgarh";
import PersonalLoanBallia from "./Pages/FooterPage/PersonalLoanBallia";
import PersonalLoanChandauli from "./Pages/FooterPage/PersonalLoanChandauli";
import PersonalLoanGhazipur from "./Pages/FooterPage/PersonalLoanGhazipur";
import PersonalLoanVaranasi from "./Pages/FooterPage/PersonalLoanVaranasi";
import BusinessLoanAzamgarh from "./Pages/FooterPage/BusinessLoanAzamgarh";
import BusinessLoanBallia from "./Pages/FooterPage/BusinessLoanBallia";
import BusinessLoanChandauli from "./Pages/FooterPage/BusinessLoanChandauli";
import BusinessLoanGhazipur from "./Pages/FooterPage/BusinessLoanGhazipur";
import BusinessLoanVaranasi from "./Pages/FooterPage/BusinessLoanVaranasi";
import NewCarLoanAzamgarh from "./Pages/FooterPage/NewCarLoanAzamgarh";
import NewCarLoanBallia from "./Pages/FooterPage/NewCarLoanBallia";
import NewCarLoanChandauli from "./Pages/FooterPage/NewCarLoanChandauli";
import NewCarLoanGhazipur from "./Pages/FooterPage/NewCarLoanGhazipur";
import NewCarLoanVaranasi from "./Pages/FooterPage/NewCarLoanVaranasi";
import UsedCarLoanAzamgarh from "./Pages/FooterPage/UsedCarLoanAzamgarh";
import UsedCarLoanBallia from "./Pages/FooterPage/UsedCarLoanBallia";
import UsedCarLoanChandauli from "./Pages/FooterPage/UsedCarLoanChandauli";
import UsedCarLoanGhazipur from "./Pages/FooterPage/UsedCarLoanGhazipur";
import UsedCarLoanVaranasi from "./Pages/FooterPage/UsedCarLoanVaranasi";
import PrivacyPolicy from './Pages/FooterPage/PrivacyPolicy';
import TermsAndConditions from './Pages/FooterPage/TermsAndConditions';
import AssociateProgram from "./Pages/AssociateProgram";
import Appointment from "./Pages/Appointment";
import BusinessPartner from "./Pages/BusinessPartner";
import MSMELoan from "./Pages/MSMELoan";
import ProjectLoan from "./Pages/ProjectLoan";
import Blog from "./components/Blog";
import PersonalBlog from "./components/PersonalBlog";
import ContactFloatingButtons from './components/ContactFloatingButtons';


import BlogDetail from "./components/BlogDetail"; // Ye NAYA detail component hai
import FAQ from "./Pages/FAQ";
function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about-us" element={<AboutUs/>} />
        <Route path="company" element={<CompanyBranch/>} />
        <Route path="/personal" element={<PersonalLoan/>} />
        <Route path="/personal-type" element={<PersonalLoanTypes/>} />
        <Route path="/casprofinanace" element={<WhyCasproFinance/>} />
        <Route path="home-loan" element={<HomeLoan/>} />
        <Route path="eligibility-criteria" element={<EligibilityCriteria/>} />
        <Route path="documents" element={<DocumemtsRequired/>} />
        <Route path="business" element={<BusinessLoan/>} />
        <Route path="eligibility"element={<Eligibility/>}/>
        <Route path="typeofbusinessLoan"element={<TypeOfBusinessLoan/>}/>
        <Route path="carloan-Balance"element={<CarLoanBalanceTransferTopup/>}/>
       <Route path="loan-againstcar"element={<LoanAgainstCar/>}/>
        <Route path="refinance"element={<RefinancePurchase/>}/>
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/home-loan-in-azamgarh"element={<HomeLoanAzamgarh/>}/>
        <Route path="/home-loan-in-ballia"element={<HomeLoanBallia/>}/>
        <Route path="/home-loan-in-varanasi"element={<HomeLoanVaranasi/>}/>
        <Route path="/home-loan-in-ghazipur" element={<HomeLoanGhazipur />} />
        <Route path="/home-loan-in-chandauli" element={<HomeLoanChandauli />} />
        <Route path="/personal-loan-in-azamgarh" element={<PersonalLoanAzamgarh />} />
        <Route path="/personal-loan-in-ballia" element={<PersonalLoanBallia />} />
        <Route path="/personal-loan-in-chandauli" element={<PersonalLoanChandauli />} />
        <Route path="/personal-loan-in-ghazipur" element={<PersonalLoanGhazipur />} />
        <Route path="/personal-loan-in-varanasi" element={<PersonalLoanVaranasi />} />
        <Route path="/business-loan-in-azamgarh" element={<BusinessLoanAzamgarh />} />
        <Route path="/business-loan-in-ballia" element={<BusinessLoanBallia />} />
        <Route path="/business-loan-in-chandauli" element={<BusinessLoanChandauli />} />
        <Route path="/business-loan-in-ghazipur" element={<BusinessLoanGhazipur />} />
        <Route path="/business-loan-in-varanasi" element={<BusinessLoanVaranasi />} />
        <Route path="/business-loan-in-chandauli" element={<BusinessLoanChandauli />} />
        <Route path="/new-car-loan-in-azamgarh" element={<NewCarLoanAzamgarh />} />
        <Route path="/new-car-loan-in-ballia" element={<NewCarLoanBallia />} />
        <Route path="/new-car-loan-in-chandauli" element={<NewCarLoanChandauli />} />
        <Route path="/new-car-loan-in-ghazipur" element={<NewCarLoanGhazipur />} />
        <Route path="/new-car-loan-in-varanasi" element={<NewCarLoanVaranasi />} />
        <Route path="/used-car-loan-in-azamgarh" element={<UsedCarLoanAzamgarh />} />
        <Route path="/used-car-loan-in-ballia" element={<UsedCarLoanBallia />} />
        <Route path="/used-car-loan-in-chandauli" element={<UsedCarLoanChandauli />} />
        <Route path="/used-car-loan-in-ghazipur" element={<UsedCarLoanGhazipur />} />
        <Route path="/used-car-loan-in-varanasi" element={<UsedCarLoanVaranasi />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/appointment"element={<Appointment/>}/>
        <Route path="/msme-loan" element={<MSMELoan />} />
        <Route path="/project-loan" element={<ProjectLoan />} />
        <Route path="/associate-program" element={<AssociateProgram />} />
        <Route path="/business-partner" element={<BusinessPartner />} />

<Route path="/blogs" element={<Blog />} /> 


<Route path="/blog/:id" element={<BlogDetail />} />
        </Routes>
      <Footer />
       <ContactFloatingButtons />
    </Router>
  );
}

export default App;